<template>
  <div class="lunbo" :class="name" :style="{ height: h + 'px' }">
    <div class="left" @click="turnLeft"></div>
    <div class="right" @click="turnRight"></div>
    <div class="swiper-container">
      <div
        class="swiper-wrapper"
        :style="{ transform: isIE ? '' : 'translate3d(-110px, 0px, 0px)' }"
      >
        <div class="swiper-slide" v-for="(item, index) in banners" :key="index">
          <img
            :src="item"
            :key="index"
            @click="getBigImg(item, index)"
            :style="{ border: isSelected == index ? '1px solid #2587FF' : '' }"
          />
        </div>
      </div>
      <div class="swiper-pagination"></div>
    </div>
  </div>
</template>

<script>
import 'swiper/swiper-bundle.css';
import Swiper from 'swiper/swiper-bundle.js';
export default {
  props: ['banners', 'name', 'h'],
  data() {
    return {
      mySwipe: null,
      isSelected: null,
    };
  },
  watch: {},
  methods: {
    getBigImg(url, index) {
      this.isSelected = index;
      this.$emit('getUrl', url);
    },
    turnLeft() {
      // this.mySwipe.swipePrev()
    },
    turnRight() {
      // this.mySwipe.swipeNext()
    },
    isIE() {
      let userAgent = navigator.userAgent;
      let isIE =
        userAgent.indexOf('compatible') > -1 &&
        userAgent.indexOf('MSIE') > -1 &&
        !(userAgent.indexOf('Opera') > -1);
      return isIE;
    },
  },
  created() {},
  mounted: function() {
    let vm = this;
    // eslint-disable-next-line no-new
    this.mySwipe = new Swiper('.' + vm.name + ' .swiper-container', {
      navigation: {
        nextEl: '.right',
        prevEl: '.left',
      },
      slidesPerView: 4,
    });
  },
};
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
/*没有分页器 加scoped不会错  */
a {
  cursor: pointer;
}
.lunbo {
  margin: 0 auto;
  position: relative;
}
.swiper-container {
  height: 100%;
  ::v-deep.swiper-wrapper {
    display: flex;
    /*justify-content: space-around;*/
    justify-content: flex-start;
    /*兼容IE*/
  }
}
.swiper-slide {
  height: 100%;
  width: 60px !important;
  color: white;
  margin-right: 14px;
  img {
    cursor: pointer;
    width: 60px;
    height: 60px;
    border: 1px solid #d2d2d2;
    &:hover {
      border: 1px solid #2587ff;
    }
  }
}
.swiper-pagination {
  position: absolute;
  z-index: 20;
  bottom: 10px;
  width: 100%;
  text-align: center;
}
/*分页器的样式*/
.swiper-pagination-switch {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 8px;
  background: #6d6df8;
  margin: 0 5px;
  opacity: 0.8;
  border: 1px solid #fff;
  cursor: pointer;
}
.swiper-active-switch {
  background: #fff;
}
.left {
  width: 25px;
  height: 44px;
  background-image: url('~@/assets/img/product/left-gray.png');
  float: left;
  cursor: pointer;
  background-size: cover;
  &:hover {
    width: 25px;
    height: 44px;
    float: left;
    background-size: cover;
    background-image: url('~@/assets/img/product/left.png');
    margin-top: 8px;
    margin-right: 10px;
  }
  margin-top: 8px;
  margin-right: 10px;
}
.right {
  width: 28px;
  height: 44px;
  background-image: url('~@/assets/img/product/right-gray.png');
  float: right;
  cursor: pointer;
  background-size: cover;
  &:hover {
    width: 28px;
    height: 44px;
    background-size: cover;
    background-image: url('~@/assets/img/product/right.png');
    /*border: none !important;*/
    margin-top: 8px;
  }
  margin-top: 8px;
}
</style>
